import { createThunk } from 'utils/createThunk';
import * as backendAPI from 'api/backendAPI/models';
import types from 'constants/actionTypes';

export const fetchModelAdvanced = createThunk({
  apiCall: backendAPI.getModelAdvanced,
  type: types.GET_MODEL_ADVANCED_REQUEST,
});

export const fetchModelAdvancedWithFilters = createThunk({
  apiCall: backendAPI.getModelAdvancedWithFilters,
  type: types.GET_MODEL_ADVANCED_WITH_FILTERS_REQUEST,
});

export const deleteAdvancedFilter = (deleteFilter) => ({
  type: types.DELETE_ADVANCED_FILTERS,
  payload: deleteFilter,
})

export const addAdvancedFilter = (filter) => ({
  type: types.ADD_ADVANCED_FILTERS,
  payload: filter,
});

export const clearAdvancedFilters = () => ({
  type: types.CLEAR_ADVANCED_FILTERS,
});
